import React from 'react';

interface IIconAfterProps {
	className?: string;
}

export const IconAfter = ({ className }: IIconAfterProps) => {
	return (
		<svg width="24" height="25" viewBox="0 0 24 25" fill="none" className={className}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.81289 22.461L12.9557 19.3181L11.8951 18.2575L10.0326 20.12L10.0326 11.9783L8.53256 11.9783L8.53256 20.12L6.67003 18.2575L5.60937 19.3181L8.75223 22.461C9.04513 22.7539 9.52 22.7539 9.81289 22.461ZM15.2707 4.88419L15.2707 13.0259L13.7707 13.0259L13.7707 4.8842L11.9081 6.74672L10.8475 5.68606L13.9903 2.5432C14.2832 2.25031 14.7581 2.25031 15.051 2.5432L18.1938 5.68606L17.1332 6.74672L15.2707 4.88419Z"
				fill="#3D3D3D"
			/>
		</svg>
	);
};
